import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { Container } from '../..';
import TAGTabs from '../elements/TAGTabs/TAGTabs';
import ADTable from './Table';
import TAGTypography from '../elements/TAGTypography/TAGTypography';

var Compare = function Compare(_ref) {
  var contents = _ref.contents,
      tabs = _ref.tabs,
      title = _ref.title;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var mobileWidth = useMediaQuery('(max-width:420px)');
  return React.createElement(Container, null, React.createElement(TAGTypography, {
    variant: "h1",
    color: "text.primary",
    sx: {
      paddingBottom: mobileWidth ? '21px' : '36px'
    }
  }, title), React.createElement(TAGTabs, {
    elevated: tabs.elevated,
    iconName: tabs.iconName,
    tabTheme: tabs.tabTheme,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    tabs: tabs.tabs
  }), React.createElement(ADTable, {
    border: contents[activeTab].border,
    variant: contents[activeTab].variant,
    fontSize: contents[activeTab].fontSize,
    tableContent: contents[activeTab].tableContent,
    footnote: contents[activeTab].footnote,
    branding: contents[activeTab].branding
  }));
};

export default Compare;